// extracted by mini-css-extract-plugin
module.exports = {"icono":"Conectividad__icono__1-HAX","texto_icono":"Conectividad__texto_icono__hwgTr","accordion":"Conectividad__accordion__2Uha0"};